<template>
    <el-drawer title="发放奖品" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
        :show-close="false">
        <div class="drawer-content">
            <div>当前共选中<span class="color-danger">{{ joinUserIds.length }}</span>人</div>
            <el-form :model="formData" :rules="rules" ref="formData" label-position="top" class="MT20">
                <el-form-item prop="prizeId" label="请选择需要发放的奖品:" size="small">
                    <template v-if="prizeList && prizeList.length > 0">
                        <el-radio-group v-model="formData.prizeId" style="width: 100%;">
                            <div v-for="(item, index) in prizeList" :key="index" class="MB20">
                                <el-radio :label="item.id" border style="width: 100%;">{{ item.prizeItem }}{{ item.prizeInfo }}</el-radio>
                            </div>
                        </el-radio-group>
                    </template>
                    <div v-else>
                        <el-empty description="暂无奖品">
                            <el-button v-if="$utils.have('/share/activity/prize/list')" type="primary" size="small"
                                @click="$router.push(`/promotion/shareActivity/award/list?shareActivityId=${shareActivityId}`)">查看奖品列表</el-button>
                        </el-empty>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button v-if="!btnLoading" @click="close">取消</el-button>
            <el-button type="primary" @click="onSubmit" :loading="btnLoading">确认</el-button>
        </div>
    </el-drawer>
</template>

<script>
export default {
    props: {
        shareActivityId: {
            type: [Number, String],
            default: ''
        }
    },
    data() {
        return {
            drawerShow: false,
            btnLoading: false,
            prizeList: [],
            joinUserIds: [],
            formData: {
                prizeId: ""
            },
            rules: { prizeId: [{ required: true, message: "请选择发放奖品" }] }
        }
    },
    mounted() {
        this.getPrizeList()
    },
    methods: {
        getPrizeList() {
            this.$request({
                url: '/share/activity/prize/list',
                method: "POST",
                params: {
                    shareActivityId: this.shareActivityId,
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.prizeList = result || []
                    } else {
                        // this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    // this.$message.error("请求错误");
                })
                .finally(() => {

                });
        },
        show(ids) {
            this.joinUserIds = ids;
            this.drawerShow = true;
        },
        close() {
            this.joinUserIds = [];
            this.formData.prizeId = "";
            this.drawerShow = false;
        },
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true
                    this.$request({
                        url: '/shareActivity/joinedUser/award',
                        method: "POST",
                        data: {
                            joinUserIds: this.joinUserIds,
                            prizeId: this.formData.prizeId,
                            shareActivityId: this.shareActivityId
                        },
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('update');
                                this.close();
                            } else {
                                this.$message.error(msg || "请求失败");
                            }
                        })
                        .catch(() => {
                            this.$message.error("请求错误");
                        })
                        .finally(() => {
                            this.btnLoading = false
                        });
                }
            });
        },
    }
}
</script>